module.exports = __webpack_public_path__ + "static/media/1.0d88e426.jpg";